import { Helmet } from "react-helmet";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import RpcEndpointsTab from "../../components/rpc-endpoints/endpoints/RpcEndpointsTab";
import RpcEndpointsPlansTab from "../../components/rpc-endpoints/plans/RpcEndpointsPlansTab";
import ListBulletIcon from "./../../assets/icons/list-bullet.svg?react";
import CubeIcon from "./../../assets/icons/cube-transparent.svg?react";
import { RpcEndpointsPlansUrl, RpcEndpointsUrl } from "../../utils/urls";
import { Typography, Tabs, TabOptions } from "djuno-design";
import useServiceType from "../../hooks/useServiceType";

export const RpcEndpontsPageMenus: TabOptions = [
  {
    label: (
      <div className="flex items-center gap-1">
        <CubeIcon className="w-3" />
        Endpoints
      </div>
    ),
    url: RpcEndpointsUrl,
    element: <RpcEndpointsTab />,
    testId: "1th-tab",
  },
  {
    label: (
      <div className="flex items-center gap-1 plans">
        <ListBulletIcon className="w-3" />
        Plans
      </div>
    ),
    url: RpcEndpointsPlansUrl,
    element: <RpcEndpointsPlansTab />,
    testId: "2th-tab",
  },
];

const RpcEndpointsPage = () => {
  const { serviceType } = useServiceType(import.meta.env.VITE_RPC_SERVICE_TYPE);
  return (
    <>
      <Helmet>
        <title>
          {import.meta.env.VITE_APP_NAME} | {serviceType?.ServiceName || ""}
        </title>
        <meta
          name="description"
          content="RPC-endpoints, or Remote Procedure Call endpoints, are a fundamental aspect of distributed computing systems, enabling communication between different components or services across a network"
        />
      </Helmet>
      <div className="flex items-center justify-between h-20">
        <div className="px-6 items-center justify-between flex flex-1 transition duration-150">
          <Typography.Title level={5} className="!mb-0">
            {serviceType?.ServiceName}
          </Typography.Title>
        </div>
        {/* <div className="mr-6 w-96"></div> */}
      </div>
      <div className="mx-6">
        <Tabs
          options={RpcEndpontsPageMenus.map((o) => ({
            label: o.label,
            url: o.url,
            testId: o.testId,
            isVisible: o.isVisible,
          }))}
        />
        <div className="py-6">
          <Outlet />
        </div>
      </div>
    </>
  );
};
export default RpcEndpointsPage;
